/**
 * Tags are an extensible data structure used for keeping track of additional data (e.g., services, fuel availability)
 * for airports and businesses.
 */
var Tag = /** @class */ (function () {
    function Tag() {
    }
    Object.defineProperty(Tag.prototype, "displayName", {
        /**
         * Returns the display name of the tag (last portion of the name), or null if this tag is not meant for user display
         * (e.g., "Fuel::Providers::", which is only used for grouping).
         */
        get: function () {
            return (this.tagName || '').split('::').slice(-1)[0] || null;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses tag
     * @param data {any} Tag as returned by API
     * @return {Tag} Parsed tag
     */
    Tag.parse = function (data) {
        return Object.assign(new Tag(), {
            tagId: data.tagId,
            tagName: data.tagName,
            isActive: data.isActive
        });
    };
    return Tag;
}());
export { Tag };
